module.exports = __webpack_public_path__ + "img/middlepic01.935f5289.jpg";